import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_STARTER_DASHBOARD_CONTACT_DM = defineFcm('starter_dashboard_contact_dm')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				emailEnabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		emailEnabled: false,
	})
	.toConfig({
		owner: 'squad-capybara',
		scope: 'corgi-front-end',
		context: 'Starter dashboard email DM notification',
		description:
			'Currently English feature, US only. Determines whether to enable contact DM notification of the starter dashboard',
		import: false,
		template: {
			emailEnabled: false,
		},
	});
